/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

export type EShapeLineOfAnyPointsHitTesterToThreshold = (
	size: number,
	scale: number,
	offset: number
) => number;
